import { useUserContext } from "context/UserContext"
import { LoaderPage } from "pages/LoaderPage"
import { MockLoginPage } from "pages/MockLoginPage"
import { AuthenticationGuardProps } from "types/auth"

export const MockAuthenticationGuard: React.FC<AuthenticationGuardProps> = ({
    component,
}) => {
    const { isAuthenticated, first_name: firstName, isLoading } = useUserContext()

    const PageComponent = component
    if (isLoading || (isAuthenticated && firstName === undefined))
        return <LoaderPage />

    return isAuthenticated ? <PageComponent /> : <MockLoginPage />
}
